module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_WarrantyBox.5366112b.png";